import React from "react";
import {Tooltip} from 'react-tippy';
import store from '../components/Stores/SurveyStore';
import surveySectionStore from '../components/Stores/SurveySectionStore';

const SurveySection = (props) => {

    const sectionCardRefHandler = (node) => {
        if (node) {
            // on-mount
            surveySectionStore.registerSectionRef(props.labelText, { current: node })
        } else {
            // on-unmount
            surveySectionStore.unregisterSectionRef?.(props.labelText)
        }
    }
    
    const clickMoreInfo = () => {
        store.additionalInfoPanel.name = props.moreInfoId;
        store.additionalInfoPanel.visible = true;
    }
    
    return (
        <section className="sectionCards" ref={sectionCardRefHandler}>
            <h3 className="sectionTitle">{props.labelText}
                {(props.helpText || props.moreInfoId) &&
                    <Tooltip
                        position="bottom"
                        trigger="mouseenter"
                        animation="fade"
                        theme="dark"
                        arrow="true"
                        size="small"
                        interactive="true"
                        html={(
                            <div className="genericTooltip">
                                {props.helpText &&
                                    <span dangerouslySetInnerHTML={{ __html: props.helpText }} ></span>
                                }
                                {props.moreInfoId &&
                                    <span style={{ color:'#ade4d0'}}>Click for additional info</span>
                                }
                        </div>
                    )}
                >
                    {props.moreInfoId &&
                        <i className="fas fa-info-circle fa-xs" onClick={clickMoreInfo}></i>
                    }
                    {props.helpText &&
                        <i className="fas fa-info-circle fa-xs"></i>
                    }
                </Tooltip>
                }
            </h3>
         
            {props.labelText &&
                <hr style={{width:'88%', margin:'0px 0px 10px 0px'}} />
            }
                {props.children}
            </section>
    );
};
export default SurveySection;


